function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _dec, _dec2, _dec3, _class;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { modalify, ZengularNotification } from "zengular-ui";
import { Brick } from "zengular";
import twig from "./write-blogpost.twig";
import ZengularOverlay from "zengular-ui/bricks/zengular-overlay.brick";
import { Ajax } from "zengular-util";
import Endpoints from "../modules/constants/end-points";
import service from "../modules/services/services";
import fileChooser from "../modules/file-chooser";
import "./write-blogpost.scss";
import Guard from "../modules/validation/guard";
import LengthValidator from "../modules/validation/validator/length-validator";
import Alert from "./alert.brick";
import constraints from "../modules/constants/constraints";
import errors from "../modules/constants/errors";
import modalError from "../modules/birck-decorators/modal-error";
import errorMessages from "../modules/constants/error-messages";
var WriteBlogpost = (_dec = modalify(), _dec2 = modalError(errorMessages), _dec3 = Brick.register('write-blogpost', twig), _dec(_class = _dec2(_class = _dec3(_class = /*#__PURE__*/function (_Brick) {
  _inherits(WriteBlogpost, _Brick);

  var _super = _createSuper(WriteBlogpost);

  function WriteBlogpost() {
    _classCallCheck(this, WriteBlogpost);

    return _super.apply(this, arguments);
  }

  _createClass(WriteBlogpost, [{
    key: "onInitialize",
    value: function onInitialize() {
      this.id = undefined;
      this.saved = false;
    }
  }, {
    key: "beforeRender",
    value: function beforeRender(args) {
      this.id = typeof args === "number" ? args : false;
    }
  }, {
    key: "createViewModel",
    value: function createViewModel(args) {
      if (this.id) return Ajax.get(Endpoints.blog.get(this.id)).getJson.then(function (xhr) {
        return xhr.response;
      });
    }
  }, {
    key: "onClose",
    value: function onClose() {
      if (this.saved) document.location.reload();
      if (this.deleted) document.location.href = '/user/' + service.User.current.guid;
    }
  }, {
    key: "onRender",
    value: function onRender() {
      var _this = this;

      this.$$('delete').on.click(function () {
        return Alert.confirm('Törlés', 'fad fa-trash-alt', 'Biztosan törölni szeretnéd a blogpostot?', 'Törlés', 'danger', _this.delete.bind(_this), 'Mégse', "primary");
      });
      this.$$('status').on.click(function (event, target) {
        return target.dataset.status = target.dataset.status === 'on' ? 'off' : 'on';
      });
      this.$$('close').on.click(function () {
        return _this.close();
      });
      this.$$('header-image').on.click(function (event, target) {
        return _this.$$('file-chooser').node.click();
      });
      this.$$('file-chooser').on.input(function (event, target) {
        return fileChooser(target, service.SiteData.config['article-header-max-filesize'], _this.$$('header-image').node);
      });
      this.$$('ok').on.mouse.click(this.save.bind(this));
    }
  }, {
    key: "delete",
    value: function _delete() {
      var _this2 = this;

      return Ajax.delete(Endpoints.blog.delete(this.id)).getJson.then(function (xhr) {
        _this2.deleted = true;

        _this2.close();
      });
    }
  }, {
    key: "save",
    value: function save() {
      var _this3 = this;

      var guard = new Guard();
      guard.create('title').add(new LengthValidator(constraints.blog.title.length.min, constraints.blog.title.length.max).setMessage(errors.BlogpostTitleLength));
      guard.create('lead').add(new LengthValidator(constraints.blog.lead.length.min, constraints.blog.lead.length.max).setMessage(errors.BlogpostLeadLength));
      guard.create('body').add(new LengthValidator(constraints.blog.body.length.min, constraints.blog.body.length.max).setMessage(errors.BlogpostBodyLength));
      var data = {
        lead: this.$$('lead').node.value.trim(),
        body: this.$$('text').node.value.trim(),
        title: this.$$('title').node.value.trim(),
        status: this.$$('status').node.dataset.status === 'on'
      };
      ZengularOverlay.show();
      guard.test(data).catch(function (error) {
        return _this3.handleError(error);
      }).then(function () {
        var files = _this3.$$('file-chooser').node.files.length ? _this3.$$('file-chooser').node.files[0] : [];
        var url = _this3.id === false ? Endpoints.blog.save() : Endpoints.blog.save(_this3.id);
        return Ajax.upload(url, data, files).get;
      }).then(function (xhr) {
        return _this3.handleXhr(xhr);
      }).then(function () {
        return _this3.saved = true;
      }).then(function () {
        return _this3.okay();
      }).catch(function () {}).finally(function () {
        return ZengularOverlay.hide();
      });
    }
  }]);

  return WriteBlogpost;
}(Brick)) || _class) || _class) || _class);
export { WriteBlogpost as default };